export default __webpack_public_path__ + "static/media/careers-bg-mobile.1f6eb236.png";